const Productos = {
    Skype: '#0078d4',
    OneDrive: '#0078d4',
    PowerPoint: '#b7472a',
    Word: '#2b579a',
    Visio: '#3955a3',
    Office: '#d83b01',
    Excel: '#217346',
    Teams: '#6264a7',
    Planner: '#31752f',
    toDo: '#212121'
}
const Messaging = {
    Warning: '#fff4ce',
    Success: '#dff6dd',
    Away: '#ffaa44',
    ErrorBlock: '#fde7e9',
    SevereWarning: '#fed9cc',
    SevereWarningIcon: '#d83b01',
    ErrorBlockIcon: '#a80000',
    SuccessIcon: '#107c10',
    SuccessIconBlue: '#0078D3',
    waitingIcon: '#ca5010'

}
const IPERC = {
    A: '#F20505',
    M: '#F2E205',
    B: '#7CF205',
    Red: '#A62940',
    number: '#605e5c',
    whiteNumber: '#ffffff'
}

const Icons = {
    primary: '#0078d4',
    delete: '#bebbb8'
}

const Bases = {
    blueLigth: '#ECF6FD',
    HeaderGroup: '#F3F2F1',
    BackgroundNavOutlook: "#F3F2F1",
    BackgroundToDo: "#FAF9F8",
    RowSelect: "#EEF6FB",
    primary: '#0078D3',//'#0078d4',
    delete: '#bebbb8',
    Negro: '#2E2625',
    Gris: '#d2d0ce',
    neutralLighterAlt: '#faf9f8',
    neutralSecondaryAlt: '#8a8886',
    ambar: '#ffb900',
}

const CUADRO_MANDO = {
    BlancoHumo: '#E3E7E9',
    VerdeNeutro: '#767BB7',
    Celeste: '#678CDC',
    Magenta: '#EE83A7',
}
const COLORES = {
    Productos,
    Messaging,
    IPERC,
    Icons,
    Bases,
    CUADRO_MANDO
}

export default COLORES